import {Language, languages} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<Language>;

export const LanguageSelect = (props: Props) => {
  const {options = languages, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
